
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    redirect: "/order",
    children: [
      {
        path: "/Order",
        name: "Order",
        component: () => import("../views/Order.vue"),
      },
      {
        path: "/Admin",
        name: "Admin",
        component: () => import("../views/Admin.vue"),
        meta: { 
          role: "超级管理员"
        }
      },
      {
        path: "/wxAdmin",
        name: "wxAdmin",
        component: () => import("../views/wxAdmin.vue"),
        meta: { 
          role: "超级管理员"
        }
      },
      {
        path: "/UpdateOrder",
        name: "UpdateOrder",
        component: () => import("../views/UpdateOrder.vue"),
      },
      {
        path: "/EditAdmin",
        name: "EditAdmin",
        component: () => import("../views/EditAdmin.vue")
      },
      {
        path: "/EditWxAdmin",
        name: "EditWxAdmin",
        component: () => import("../views/EditWxAdmin.vue")
      },
      {
        path: "/Visualization",
        name: "Visualization",
        component: () => import("../views/Visualization.vue")
      }
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;


